export function arrayToObject (array, key) {
	return array.reduce((obj, item) => {
		return {
			...obj,
			[item[key]]: item,
		};
	}, {});
};

export function sortBy (array, key) {
	return [...(array ?? [])].sort((a, b) => {
		if (a[key].toLowerCase() > b[key].toLowerCase()) return 1;
		if (a[key].toLowerCase() < b[key].toLowerCase()) return -1;
		return 0;
	});
}

export function byteArrayToHexString (byteArray) {
	return Array.from(byteArray, byte => {
		return ('0' + (byte & 0xFF).toString(16)).slice(-2);
	}).join('');
}
